import {  Text,  Card, Divider, useMantineTheme, Title,Flex,Stack } from '@mantine/core';
import TransportBadge from './component/TransportBadge';
import { IconWheelchair } from '@tabler/icons-react';
import AllergyBadge from './component/AllergyBadge';


export function MemberImmigration(props) {
    const theme = useMantineTheme();
    let data = { genre: "", dateOfBirth: Date.now() }
    data = { ...props.props }
    return (
        <Card
            radius="md"
            withBorder
            p="lg"
            sx={(theme) => ({
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
            })}
        >
            <Card.Section bg={theme.colors.blue} p={"xs"} >
                <Title color='white' align="center" order={3}  >
                    Informations
                </Title>
            </Card.Section>
            <Card.Section m={"xs"}>
                <Stack>
                    <Flex>
                        <Text align='left'>Catégorie d'immigration : {data?.immigrationStatus}</Text>
                    </Flex>
                    <Flex>
                        <Text align='left'> Date du status d'immigration : {new Date(data?.dateOfImmigrationStatus).toLocaleString("fr-CA",{"month":"long","day":"numeric","year":"numeric"})}</Text>
                    </Flex>
                    <Flex>
                        <Text align='left'> Date d'arrivé au Québec : {new Date(data?.dateOfArrivalCountry).toLocaleString("fr-CA",{"month":"long","day":"numeric","year":"numeric"})} </Text>
                    </Flex>
                    <Flex>
                        <Text align='left'> Date d'arrivé à la MRC : {new Date(data?.dateOfArrivalRegion).toLocaleString("fr-CA",{"month":"long","day":"numeric","year":"numeric"})} </Text>
                    </Flex>
                </Stack>
            <Divider my={"md"} />
            <Stack>
                <Flex>
                    <Text align='left'>Pays d'origine : {data?.countryOfOrigins}</Text>
                </Flex>
                <Flex>
                    <Text align='left'> Status d'emploi : {data?.employmentStatus}</Text>
                </Flex>
                <Flex>
                    <Text align='left'>Status civil : {data?.maritalStatus}</Text>
                </Flex>
                <Flex>
                    <Text align='left'>Niveau Scolaire : {data?.education.diplomas.toString()}</Text>
                </Flex>
                <Flex>
                    <Text align='left'>Domaine d'étude : {data?.education.fieldOfStudy.toString()}</Text>
                </Flex>
            </Stack>
            </Card.Section>
        </Card>
    );
}